import { render, staticRenderFns } from "./GigExtensionSelector.vue?vue&type=template&id=a141501c&scoped=true&"
import script from "./GigExtensionSelector.vue?vue&type=script&lang=js&"
export * from "./GigExtensionSelector.vue?vue&type=script&lang=js&"
import style0 from "./GigExtensionSelector.vue?vue&type=style&index=0&id=a141501c&scoped=true&lang=scss&"
import style1 from "./GigExtensionSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a141501c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent})
